import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    GroupItemCategoryActions,
    ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID,
    ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID_SUCCESS,
    ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID_FAILURE,
    ACTION_GROUPITEMCATEGORIES_CLEAR,
    ACTION_GROUPITEMCATEGORIES_FILTER
} from '../actions/groupItemCategory';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IGroupItemCategoryState {
    formData: Dtos.GroupItemCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.GroupItemCategory[];
    formLength: number;
}

const initialState: IGroupItemCategoryState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: IGroupItemCategoryState, _isLoading: boolean): IGroupItemCategoryState {
    const newState: IGroupItemCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IGroupItemCategoryState,
    formData: Dtos.GroupItemCategory[],
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IGroupItemCategoryState {
    const newState: IGroupItemCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: IGroupItemCategoryState, formFilter: IFormFilter): IGroupItemCategoryState {

    const groupItemCategories: Dtos.GroupItemCategory[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = groupItemCategories ? groupItemCategories.length : 0;

    const formFilteredData = groupItemCategories ? groupItemCategories.filter(p => (formFilter.showInActive) &&
        (formFilter.search == "" || p.groupItemTemplateCategory.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: IGroupItemCategoryState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function loadFailure(state: IGroupItemCategoryState, responseStatus: Dtos.ResponseStatus): IGroupItemCategoryState {
    const newState: IGroupItemCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IGroupItemCategoryState, propertiesToClear?: string[]): IGroupItemCategoryState {

    if (!propertiesToClear) {
        const newState: IGroupItemCategoryState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

const GroupItemCategoryReducer: Reducer<IGroupItemCategoryState> = (state: IGroupItemCategoryState = initialState, action: GroupItemCategoryActions) => {
    switch (action.type) {
        case ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID:
            return loading(state, true);
        case ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID_SUCCESS:
            return loadSuccess(state, action.formData, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_GROUPITEMCATEGORIES_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_GROUPITEMCATEGORIES_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default GroupItemCategoryReducer;